import type { GestureResponderEvent } from 'react-native';

import { Text, theme } from '@squire/ui';

import { InfoCircleFilledIcon, InfoCircleIcon } from '@/components/_icons';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/_shared/Tooltip';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { PriceRangeTooltipProps } from './types';

function PriceRangeTooltip({
  testID,
  variant = 'default',
}: PriceRangeTooltipProps) {
  const { t } = useScreenTranslations('PriceRangeTooltip');

  // On web the press would otherwise bubble up and select the parent card.
  const handlePress = (event?: GestureResponderEvent) => {
    event?.stopPropagation?.();
  };

  return (
    <Tooltip placement="bottom">
      <TooltipTrigger
        onPress={handlePress}
        hitSlop={theme.spacing[3]}
        style={styles.trigger}
        testID={testID}
        accessibilityRole="button"
        accessibilityLabel={t('accessibilityLabel')}
      >
        {variant === 'cart' ? (
          <InfoCircleIcon size={16} strokeWidth={1.5} color="cartIconPrimary" />
        ) : (
          <InfoCircleFilledIcon size={16} color="iconTertiary" />
        )}
      </TooltipTrigger>
      <TooltipContent>
        <Text variant="m" color="textPrimaryInverse">
          {t('content')}
        </Text>
      </TooltipContent>
    </Tooltip>
  );
}

PriceRangeTooltip.displayName = 'PriceRangeTooltip';
export { PriceRangeTooltip };
